import classNames from "classnames";
import { SocialSharing } from "components/SocialSharing";
import { useTranslation } from "features/translations";
import {
  Action,
  Container,
  Heading2,
  HighlightedArticle,
  Icon,
  NewsItems,
  PopularTags,
  RenderIf,
} from "shared/components";
import { VIEW_MODES } from "shared/contexts/ViewMode";
import { useCollectedNewsRender } from "shared/hooks";

import styles from "./Content072.module.scss";

export const Content072 = ({ payload }) => {
  const title = payload?.headline ?? "";
  const highlightedArticle = payload?.highlightedArticle ?? null;

  const { t } = useTranslation();

  const { feed, isCompleted, renderNext, limit, articleCategories } =
    useCollectedNewsRender({
      payload,
      widgetNumber: "072",
    });

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.top}>
          <Heading2 className={styles.title}>{title}</Heading2>
          <RenderIf viewMode={VIEW_MODES.DESKTOP}>
            <SocialSharing
              title={t("socialTitle")}
              inline
              appearance="brand"
              buttonClassName={styles.button}
            />
          </RenderIf>
        </div>
        {highlightedArticle && <HighlightedArticle item={highlightedArticle} />}
        <div className={styles.blocks}>
          <div className={styles.feed}>
            <NewsItems items={feed} className={styles.items} limit={limit} />
            {!isCompleted && (
              <Action onClick={renderNext} className={styles.more}>
                <div className={styles.loader}>
                  <div className={classNames(styles["loader-wrapper"])}>
                    {t("lazyRendering")}
                    <Icon className={styles.icon} name="loader" />
                  </div>
                </div>
              </Action>
            )}
          </div>
          <div className={styles["tags-list"]}>
            <PopularTags tags={articleCategories} />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Content072;
